import { useEffect, useState } from 'react';
import { adminApi, type AdminTrack } from '../../lib/api';
import { SortableList } from './SortableList';
import { Field, Modal } from './LiveAdminPanel';

export default function TrackAdminPanel() {
  const [items, setItems] = useState<AdminTrack[]>([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState<{ data: Partial<AdminTrack>; mp3?: File; cover?: File } | null>(null);

  async function reload() {
    setLoading(true);
    setItems(await adminApi.trackList());
    setLoading(false);
  }
  useEffect(() => { reload(); }, []);

  async function reorder(next: AdminTrack[]) {
    setItems(next);
    await adminApi.trackReorder(next.map((i) => i.id));
  }

  async function remove(id: number) {
    if (!confirm('Eliminare questa traccia?')) return;
    await adminApi.trackDelete(id);
    reload();
  }

  async function save() {
    if (!editing) return;
    const fd = new FormData();
    fd.append('title', editing.data.title || '');
    if (editing.data.year) fd.append('year', String(editing.data.year));
    fd.append('is_active', editing.data.is_active ? 'true' : 'false');
    if (editing.mp3) fd.append('mp3_file', editing.mp3);
    if (editing.cover) fd.append('cover_image', editing.cover);

    if (editing.data.id) await adminApi.trackUpdate(editing.data.id, fd);
    else await adminApi.trackCreate(fd);
    setEditing(null);
    reload();
  }

  return (
    <section className="admin-panel">
      <div className="admin-panel-head">
        <h2>Tracce</h2>
        <button className="btn-primary" onClick={() => setEditing({ data: { title: '', is_active: true } })}>+ Nuova traccia</button>
      </div>

      {loading && <p className="muted">Caricamento...</p>}
      {!loading && items.length === 0 && <p className="muted">Nessuna traccia.</p>}

      <SortableList
        items={items}
        onReorder={reorder}
        renderItem={(item, handle) => (
          <div className="admin-row">
            {handle}
            {item.cover_image && <img src={item.cover_image} alt="" className="admin-thumb admin-thumb-sq" />}
            <div className="admin-row-main">
              <div className="admin-row-title">
                <strong>{item.title}</strong>
                {item.year && <span className="muted"> ({item.year})</span>}
                {!item.is_active && <span className="badge-muted">nascosta</span>}
              </div>
              {item.mp3_file && <audio controls src={item.mp3_file} preload="none" style={{ width: '100%', maxWidth: 320 }} />}
            </div>
            <div className="admin-row-actions">
              <button className="btn-ghost" onClick={() => setEditing({ data: { ...item } })}>Modifica</button>
              <button className="btn-danger" onClick={() => remove(item.id)}>Elimina</button>
            </div>
          </div>
        )}
      />

      {editing && (
        <Modal title={editing.data.id ? 'Modifica traccia' : 'Nuova traccia'} onClose={() => setEditing(null)}>
          <Field label="Titolo">
            <input value={editing.data.title || ''} onChange={(e) => setEditing({ ...editing, data: { ...editing.data, title: e.target.value } })} />
          </Field>
          <Field label="Anno">
            <input type="number" value={editing.data.year || ''} onChange={(e) => setEditing({ ...editing, data: { ...editing.data, year: e.target.value ? Number(e.target.value) : null } })} />
          </Field>

          {editing.data.cover_image && !editing.cover && (
            <div className="admin-field">
              <span>Cover attuale</span>
              <img src={editing.data.cover_image} alt="" style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, display: 'block' }} />
            </div>
          )}
          {editing.cover && (
            <div className="admin-field">
              <span>Nuova cover (preview)</span>
              <img src={URL.createObjectURL(editing.cover)} alt="" style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, display: 'block' }} />
              <button type="button" className="btn-ghost" style={{ marginTop: 6 }} onClick={() => setEditing({ ...editing, cover: undefined })}>Annulla nuova cover</button>
            </div>
          )}
          <Field label={editing.data.cover_image ? 'Cambia cover' : 'Cover'}>
            <input type="file" accept="image/*" onChange={(e) => setEditing({ ...editing, cover: e.target.files?.[0] })} />
          </Field>

          {editing.data.mp3_file && !editing.mp3 && (
            <div className="admin-field">
              <span>MP3 attuale</span>
              <audio controls src={editing.data.mp3_file} preload="none" style={{ width: '100%' }} />
              <a href={editing.data.mp3_file} target="_blank" rel="noreferrer" className="muted" style={{ fontSize: 12 }}>Apri file</a>
            </div>
          )}
          {editing.mp3 && (
            <div className="admin-field">
              <span>Nuovo MP3 selezionato</span>
              <div className="muted">{editing.mp3.name} ({Math.round(editing.mp3.size / 1024)} KB)</div>
              <button type="button" className="btn-ghost" style={{ marginTop: 6 }} onClick={() => setEditing({ ...editing, mp3: undefined })}>Annulla nuovo MP3</button>
            </div>
          )}
          <Field label={editing.data.mp3_file ? 'Cambia MP3' : 'File MP3'}>
            <input type="file" accept="audio/*" onChange={(e) => setEditing({ ...editing, mp3: e.target.files?.[0] })} />
          </Field>

          <Field label="Visibile">
            <input type="checkbox" checked={!!editing.data.is_active} onChange={(e) => setEditing({ ...editing, data: { ...editing.data, is_active: e.target.checked } })} />
          </Field>
          <div className="modal-actions">
            <button className="btn-ghost" onClick={() => setEditing(null)}>Annulla</button>
            <button className="btn-primary" onClick={save}>Salva</button>
          </div>
        </Modal>
      )}
    </section>
  );
}
